import { Component, Input } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule, JsonPipe, SlicePipe } from '@angular/common';
import { BaseRules, TextValues } from './kansas-model';
import { UimuiBaseStateComponent } from '../uimui-base-state.component';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-kansas',
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    CommonModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    JsonPipe,
    TruncateModule,
    TooltipModule
  ],
  templateUrl: './kansas.component.html',
  host: {
    class: 'state-wrapper',
  },
})
export class KansasComponent extends UimuiBaseStateComponent<BaseRules, TextValues> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('kansas', form);
    } else {
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('kansas', null);
    } else {
    }
  }
}
